import React from 'react';
import { Typography } from 'antd';
import { formatVisibleNumber } from '../selfcare360/selfcare360Scales';

const { Text } = Typography;

const AverageTagSmall = ({ average, color, type, isNps }) => {
    const bgColor = isNps ? '#009688' : color;
    const textColor = isNps ? '#fff' : (String(color).toLowerCase() === '#fbc02d' ? '#000' : '#fff');
    const safeAverage = Number(average);
    const displayValue = isNps
        ? average
        : `${formatVisibleNumber(Number.isFinite(safeAverage) ? safeAverage : 0)}%`;

    return (
        <div
            style={{
                position: 'absolute',
                top: type == 2 ? 140 : 40,
                right: 15,
                zIndex: 10,
                width: 120,
                height: 50,
                backgroundColor: bgColor,
                color: textColor,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 12,
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            }}
        >
            <Text style={{ fontSize: 28, fontWeight: 'bold', color: textColor }}>
                {displayValue}
            </Text>
        </div>
    );
};

export default AverageTagSmall;
